import { db } from "./config";
import { getAuth } from "firebase/auth";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  setDoc,
  updateDoc,
  getDoc,
} from "firebase/firestore";

const initialHomes = [
  {
    address: "123 Neighbor Lane",
    price: 5000,
    image:
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8u77FDdKAsaolb2iARP8uwCtOIkWJdpfzyMxHg", // Keep for backward compatibility
    images: [
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8u77FDdKAsaolb2iARP8uwCtOIkWJdpfzyMxHg",
    ], // Primary image in array
    features: ["2 Bedrooms", "Garden"],
    status: "available",
    occupancyLimit: 2,
  },
  {
    address: "456 Community Ave",
    price: 6000,
    image:
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8u5dQkU0yvrKkIcndAjHBimRqGuUTNS4p12JFh",
    images: [
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8u5dQkU0yvrKkIcndAjHBimRqGuUTNS4p12JFh",
    ],
    features: ["3 Bedrooms", "Pool"],
    status: "available",
    occupancyLimit: 3,
  },
  {
    address: "11 Tooshie Ln",
    price: 20000,
    image:
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8upUaaA2twR6BHs3eW7xiFUt9ngfhdY5zya2LP",
    images: [
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8upUaaA2twR6BHs3eW7xiFUt9ngfhdY5zya2LP",
    ],
    features: ["6 Bedrooms", "Beachfront"],
    status: "available",
    occupancyLimit: 6,
  },
  {
    address: "515 Beer Rd",
    price: 10000,
    image:
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8uoQPvjoulg36FMaVQzWBuqfx2AtYcJhNv9IUn",
    images: [
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8uoQPvjoulg36FMaVQzWBuqfx2AtYcJhNv9IUn",
    ],
    features: ["2 Bedrooms", "Yard"],
    status: "available",
    occupancyLimit: 2,
  },
  {
    address: "444 Sworld Ct",
    price: 2000,
    image:
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8urtZ3BZo7CicGRAXPkEq06uyKUemFBn31Dgd4",
    images: [
      "https://l0mf24xcgv.ufs.sh/f/GJGtgA7g2t8urtZ3BZo7CicGRAXPkEq06uyKUemFBn31Dgd4",
    ],
    features: ["Studio", "Cottage"],
    status: "available",
    occupancyLimit: 1,
  },
];

export const initializeHomes = async () => {
  const auth = getAuth();
  if (!auth.currentUser) {
    console.log("User not authenticated, skipping homes initialization");
    return;
  }

  try {
    const homesCollection = collection(db, "homes");
    const existingHomes = await getDocs(homesCollection);

    if (existingHomes.empty) {
      console.log("Initializing homes data...");
      for (const home of initialHomes) {
        await addDoc(homesCollection, {
          ...home,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        });
      }
      console.log("Homes data initialized successfully");
    }
  } catch (error) {
    console.error("Error initializing homes:", error);
    // Don't throw the error, just log it
    return null;
  }
};

export const getAllHomes = async () => {
  const auth = getAuth();
  if (!auth.currentUser) {
    return [];
  }

  try {
    const homesCollection = collection(db, "homes");
    const snapshot = await getDocs(homesCollection);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error fetching homes:", error);
    return [];
  }
};

export const purchaseHome = async (homeId, userId) => {
  try {
    const homeRef = doc(db, "homes", homeId);
    const userRef = doc(db, "users", userId);

    // Get home and user data
    const homeDoc = await getDoc(homeRef);
    const userDoc = await getDoc(userRef);

    if (!homeDoc.exists() || !userDoc.exists()) {
      throw new Error("Home or user not found");
    }

    const homeData = homeDoc.data();
    const userData = userDoc.data();

    if (homeData.status !== "available") {
      throw new Error("Home is not available");
    }

    if (userData.neighborhoodDollars < homeData.price) {
      throw new Error("Insufficient neighborhood dollars");
    }

    // Update home status and owner
    await updateDoc(homeRef, {
      status: "occupied",
      ownerId: userId,
      updatedAt: new Date().toISOString(),
    });

    // Update user's profile with new home details
    await updateDoc(userRef, {
      neighborhoodDollars: userData.neighborhoodDollars - homeData.price,
      homeId: homeId,
      address: homeData.address,
      homeImage: homeData.image,
      updatedAt: new Date().toISOString(),
    });

    return {
      success: true,
      newBalance: userData.neighborhoodDollars - homeData.price,
      address: homeData.address,
      homeImage: homeData.image,
    };
  } catch (error) {
    console.error("Error purchasing home:", error);
    throw error;
  }
};
